var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEzBreezy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4ba9c8;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.729,60.86h-31.748c-7.761,0-14.075-6.314-14.075-14.075,0-6.482,4.475-12.089,10.64-13.64,1.341-9.032,9.155-15.899,18.433-15.899,7.293,0,13.926,4.317,16.942,10.884,8.936.104,16.173,7.405,16.173,16.365,0,9.023-7.342,16.365-16.366,16.365ZM47.979,21.246c-7.699,0-14.114,6.021-14.605,13.71-.061.952-.786,1.729-1.732,1.854-4.98.663-8.735,4.951-8.735,9.975,0,5.556,4.52,10.075,10.075,10.075h31.748c6.818,0,12.366-5.547,12.366-12.365s-5.547-12.366-12.366-12.366c-.328,0-.649.026-.97.051-.893.061-1.722-.466-2.03-1.307-2.108-5.758-7.633-9.627-13.75-9.627Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.026,82.754H25.737c-1.104,0-2-.896-2-2s.896-2,2-2h41.29c2.888,0,5.237-2.349,5.237-5.236s-2.349-5.237-5.237-5.237-5.237,2.35-5.237,5.237c0,1.104-.896,2-2,2s-2-.896-2-2c0-5.094,4.144-9.237,9.237-9.237s9.237,4.144,9.237,9.237-4.144,9.236-9.237,9.236Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.653,75.518h-25.916c-1.104,0-2-.896-2-2s.896-2,2-2h25.916c1.104,0,2,.896,2,2s-.896,2-2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.546,68.28h-16.81c-1.104,0-2-.896-2-2s.896-2,2-2h16.81c1.104,0,2,.896,2,2s-.896,2-2,2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEzBreezy);
export default __webpack_public_path__ + "static/media/ezBreezy.5f18b9aeea77167bd79e62237a7b1950.svg";
export { ForwardRef as ReactComponent };